/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const SearchTabsSwitcher = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom     for any jQuery selectors    - example: $domMenu: $('.js-menu')
	 * @param {string} sl       for any string selectors    - example: slMenu: '.js-menu'
	 * @param {string} class    for any class strings       - example: classActive: 'is-active'
	 * @param {string} attr     for any attributes strings  - example: attrIndex: 'data-index'
	 */
	$domSearchTabContent: $('.search_results__items'),
	$domSearchTabButton: $('.search_popup__results-tab'),
	$domSearchBody: $('.search_popup__results'),
	classActiveItem: 'active-item',
	classLoadingItem: 'loading-data',
	classPlaceholder: 'placeholder',

	/**
	 * @description Initialize
	 * @example this.switchTabs();
	 */
	init: function() {
		this.switchTabs();
	},

	switchTabs: function() {
		// eslint-disable-next-line
		const self = this;

		function openTab(evt) {
			self.$domSearchTabContent.hide();

			self.$domSearchTabButton.removeClass(self.classActiveItem);
			setTimeout(() => {
				$('#' + evt.currentTarget.getAttribute('data-tab')).show();
			}, '200');
			$(evt.currentTarget).addClass(self.classActiveItem);
			self.$domSearchBody.toggleClass(self.classLoadingItem);
		}

		this.$domSearchTabButton.click(function(event) {
			openTab(event);
		});
	}
};

export default SearchTabsSwitcher;
